// ----------------------------------------------------------------------

/**
 * @function Paper
 * @description Styles for Mui Paper component.
 * @returns {object} MuiPaper component styles.
 * @example
 * import { Paper } from '~/theme/overrides';
 * <Paper />
 */

export default function Paper() {
  return {
    MuiPaper: {
      defaultProps: {
        elevation: 0,
      },
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
  };
}
